import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCircleOne = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25}
    height={25}
    viewBox="0 0 496.158 496.158"
    {...props}
  >
    <path
      d="M248.082.003C111.07.003 0 111.061 0 248.085c0 137 111.07 248.07 248.082 248.07 137.006 0 248.076-111.07 248.076-248.07C496.158 111.061 385.088.003 248.082.003"
      style={{
        fill: "#18a09f",
      }}
    />
    <path
      d="M278.767 145.419q-4.689-6.005-12.451-6.006-6.887 0-9.375 2.637-2.493 2.637-10.693 14.063a120 120 0 0 1-18.823 20.654q-10.623 9.228-28.345 17.578-11.866 5.567-16.553 9.082t-4.688 10.986q0 6.447 4.761 11.353 4.76 4.908 10.913 4.907 12.889 0 50.098-28.564V335.41q0 11.72 5.42 17.725 5.418 6.005 14.355 6.006 20.067 0 20.068-29.443V161.972q.001-10.545-4.687-16.553"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgIconCircleOne;
